import { Note } from "@app/models/note.model";
import { UserByUnitList } from "@app/models/profile.model";
import { UserByUnit } from "@app/models/user.model";
import { DataSelectors } from "@app/store/data/data.selectors";
import { SlideUpWindowByStudentState } from "./slide-up-window-by-student.state";
import { Store } from "@ngxs/store";

export function onLoadUsers(
    state: SlideUpWindowByStudentState,
    store: Store,
    selectedUnit: UserByUnitList
) {
    state.selectedUser = null;
    state.selectedUnit = selectedUnit;
    const objcd = state.selectedUnit.objcd;
    const renderedDataNote = store.selectSnapshot(DataSelectors.renderedDataNote);
    const notes = renderedDataNote[objcd] ?? [];
    const studentListByNotes = Array.from(new Set(notes.map((item: Note) => item.objcd))) ?? [];
    let students: UserByUnit[] = [];
    for (let student of studentListByNotes) {
        const careConneRoomList = store.selectSnapshot(DataSelectors.careConneRoomList(student as string));
        students.push(careConneRoomList);
    }

    state.students = students.filter((item) => item) ?? [];
}

export function onLoadRooms(state: SlideUpWindowByStudentState, selectedUser: UserByUnit) {
    state.selectedUser = selectedUser;
    state.allRoomData = selectedUser?.roomDataByUnit.find((item) => item.objcd === state.selectedUnit?.objcd)?.rooms ?? [];
}